// import Request from 'gd-request';
// import {StorageProvider as StorgageProvider} from "../const/storage";

import Attachment from "../../model2/attachment/attachment";
import ApiAttachmentRequest from "../api-request/api-attachment";

export default class ApiAttachment {

    constructor() {

    }

    // NEW Static

    static downloadByFileObject(payload: Attachment){

        return ApiAttachmentRequest.POST(this, 'download', {
            storageProvider     : payload.storageProvider,
            fileId              : payload.fileId,
            name                : payload.name
        })
    }

    static save(payload: Attachment[]){

        return ApiAttachmentRequest.POST(this, 'save', {
            files: payload
        })
    }

    static delete(payload: Attachment[]){

        return ApiAttachmentRequest.POST(this, 'delete',{
            files: payload
        })
    }

    static open(payload: Attachment) {

        return ApiAttachmentRequest.POST(this, 'open', {
            storageProvider : payload.storageProvider,
            fileId          : payload.fileId,
        })
    }


    // OLD


    uploadUrl() {
        return gdConfig.apiAttachment + "upload"
    }

    // open = open in a browser... original
    openUrl(fileId:ID) {
        return gdConfig.apiAttachment+"open/"+fileId;
    }

    downloadUrl(fileId:ID) {
        return gdConfig.apiAttachment+"download/"+fileId;
    }

    preview160Url(fileId:ID) {
        return gdConfig.apiAttachment+"preview/"+fileId+"/160";
    }

    preview1200Url(fileId:ID) {
        return gdConfig.apiAttachment+"preview/"+fileId+"/1200";
    }

    previewUploadsUrl(fileId:ID) {
        return gdConfig.uploadsPath + "1200px/" + fileId + ".jpg";
    }

    download(data:any) {
        if (data.storageProvider === gd.const.storageProvider.GOOGLE_DRIVE)
            gd.openInNewWindow("https://drive.google.com/uc?export=download&id="+data.fileId)
        else {
            // chto to tipo : gdConfig.apiAttachment+"download/"+fileId;
            // 'custom/download'
            gd.openInNewWindow(this.downloadUrl(data.fileId))
        }

    }

    open(data:any) {
        const { fileId } = data;
        let viewUrl;

        if (data.storageProvider === gd.const.storageProvider.GOOGLE_DRIVE) {
            const isGoogleDoc = data.fileType === gd.const.attachment.fileType.GOOGLE_DOCUMENT;
            if (isGoogleDoc) {
                switch(data.mime) {
                    case 'application/vnd.google-apps.document':        viewUrl = "https://docs.google.com/document/d/"+fileId+"/edit"; break;
                    case 'application/vnd.google-apps.spreadsheet':     viewUrl = "https://docs.google.com/spreadsheets/d/"+fileId+"/edit"; break;
                    case 'application/vnd.google-apps.drawing':         viewUrl = "https://docs.google.com/drawings/d/"+fileId+"/edit"; break;
                    case 'application/vnd.google-apps.form':            viewUrl = "https://docs.google.com/forms/d/"+fileId+"/edit"; break;
                    case 'application/vnd.google-apps.presentation':    viewUrl = "https://docs.google.com/presentation/d/"+fileId+"/edit"; break;
                    default:                                            viewUrl = "https://drive.google.com/file/d/"+fileId+"/view?usp=drivesdk";
                }
            } else {
                viewUrl = "https://drive.google.com/file/d/"+fileId+"/view?usp=drivesdk";
            }
        } else {
            viewUrl = this.openUrl(fileId);
        }

        gd.openInNewWindow(viewUrl)
    }
}
